<template>
    <div class="service-type-block" @click="action()">
        <img v-if="!hideIcon" class="icon-service" :src="consultationIcon">
        <div class="service-name mt-1" v-html="serviceName"></div>
        <div v-if="nextAvailability" class="appointment-request-title mt-2">
            <div>{{$t('next')}}:</div>
            <div v-html="nextAvailability"></div>
        </div>
        <div v-else-if="requestAppointmentTitle" class="appointment-request-title mt-2" v-html="requestAppointmentTitle"></div>
        <div v-if="showSpecialCompanyPrice" class="mt-2">
            <div class="lineThrough price-title">{{`${$t('price')}: ${ratesRangeActive ? `${$t('from')} ` : ''}${price.originalPrice} ${currency}`}}</div>
            <div class="bold">{{`${$t('specialPrice')}: ${specialCompanyPriceTitle}`}}</div>
        </div>
        <div v-else-if="showPrice" class="price-title mt-2">{{`${$t('price')}: ${ratesRangeActive ? `${$t('from')} ` : ''}${servicePrice} ${currency}`}}</div>
        <div v-if="showFirstAppointmentPrice" class="first-appointment-title">({{`${$t('firstAppointmentWithNumber')}: ${ratesRangeActive ? `${$t('from')} ` : ''}${firstAppointmentPriceTitle}`}})</div>
        <div class="mt-2" v-if="showIncludedInSubscriptionTitle" v-html="$t('includedInSubscription')"></div>
        <div class="mt-2" v-else-if="showOnlyBySubscription" v-html="$t('onlyUnderSubscription')"></div>
    </div>
</template>

<script>
import { VIDEO, INPLACE, WRITTEN, SECOND_OPINION, IMMEDIATE_VIDEO, AT_HOME, CHAT, CALL, INSURANCE, TESTS_ICON, BUDGET_ICON, OTHER_CONSULTATIONS_ICON, getConsultationIconById } from '@/constants/consultationTypes'
import { getCurrencyByDomain } from '@/constants/currencies'

export default {
    data () {
        return {
            servicesNames: {
                [INPLACE]: this.$t('serviceName.inplace'),
                [VIDEO]: this.$t('serviceName.video'),
                [WRITTEN]: this.$t('serviceName.written'),
                [SECOND_OPINION]: this.$t('serviceName.secondOpinion'),
                [IMMEDIATE_VIDEO]: this.$t('serviceName.immediate'),
                [AT_HOME]: this.$t('serviceName.atHome'),
                [CHAT]: this.$t('serviceName.chat'),
                [CALL]: this.$t('serviceName.call'),
                [INSURANCE]: this.$t('serviceName.insurance')
            }
        }
    },
    props: {
        serviceType: Number,
        price: Object,
        firstAppointmentPrice: Number,
        requestAppointmentTitle: String,
        includedInSubscription: Boolean,
        includedInCompanyService: Boolean,
        nextAvailability: String,
        hasSpecialPrice: Boolean,
        default: Boolean,
        action: Function,
        showOnlyBySubscription: Boolean,
        opensaludpassActive: Boolean,
        copaymentPrice: Number,
        ratesRangeActive: Boolean,
        tests: Boolean,
        budget: Boolean,
        hideIcon: Boolean,
        showingMoreServices: Boolean
    },
    computed: {
        currency () {
            return getCurrencyByDomain()
        },
        servicePrice () {
            return this.copaymentPrice !== null && this.copaymentPrice >= 0 ? this.copaymentPrice : this.price.currentPrice
        },
        serviceName () {
            return this.default && this.showingMoreServices ? this.$t('otherConsultationsAndServices') : this.default ? this.$t('consultationsAndServices') : this.tests ? this.$t('filters.tests') : this.budget ? this.$t('budget') : this.servicesNames[this.serviceType]
        },
        consultationIcon () {
            return this.default ? OTHER_CONSULTATIONS_ICON : this.tests ? TESTS_ICON : this.budget ? BUDGET_ICON : getConsultationIconById(this.serviceType)
        },
        showFirstAppointmentPrice () {
            return this.firstAppointmentPrice !== null && this.firstAppointmentPrice >= 0 && !this.includedInSubscription && !this.showIncludedInSubscriptionTitle
        },
        firstAppointmentPriceTitle () {
            return this.firstAppointmentPrice === 0 && !this.ratesRangeActive ? this.$t('free') : `${this.firstAppointmentPrice} ${this.currency}`
        },
        specialCompanyPriceTitle () {
            return this.firstAppointmentPrice === 0 ? this.$t('free') : `${this.price.currentPrice} ${this.currency}`
        },
        showPrice () {
            return !this.default && ((this.price && this.price.currentPrice != null && this.price.currentPrice >= 0) || (this.copaymentPrice !== null && this.copaymentPrice >= 0)) && this.serviceType !== INSURANCE && !this.includedInSubscription && !this.showIncludedInSubscriptionTitle
        },
        showIncludedInSubscriptionTitle () {
            return this.includedInSubscription || (this.includedInCompanyService && !this.opensaludpassActive)
        },
        showSpecialCompanyPrice () {
            return !this.default && !this.showIncludedInSubscriptionTitle && this.hasSpecialPrice === true
        }
    }
}
</script>

<style lang="scss" scoped>
.service-type-block{
    text-align: center;
    -webkit-box-shadow: -10px -10px 35px #fff,10px 10px 35px rgba(13,39,80,0.160784);
    box-shadow: -10px -10px 35px #fff,10px 10px 35px rgba(13,39,80,0.160784);
    padding: 1.5rem 0.5rem;
    border-radius: 23px;
    border: 1px solid #eee;
    background-color: #eee;
    flex-basis: 50%;
    font-size: 11px;
    cursor: pointer;
    color: $blue;
    max-width: 220px;
}
.icon-service{
    width: 36px;
    height: 36px;
}
.blue{
    color: $blue;
}
.appointment-request-title{
    font-weight: bold;
    text-decoration: underline;
}
.first-appointment-title{
    font-weight: bold;
    font-size: 10px;
    color: $gray-600;
}
.bold{
    font-weight: bold
}
.lineThrough{
    text-decoration: line-through;
    color: gray;
}
.service-name{
    color: $blue;
    font-weight: bold;
    text-transform: uppercase;
}
.price-title{
    color: $gray-600;
}
</style>


// WEBPACK FOOTER //
// src/components/webapp/patient/search/SearchServiceTypeBlock.vue